import api from '@/utils/api';

export function getWishlist() {
  return api.get('api/v1/wishlist/');
}

export function deleteWishlistItem(itemId: number) {
  return api.delete(`api/v1/wishlist/item/${itemId}/`);
}

export function moveWishlistItem(itemId: number) {
  return api.get(`api/v1/wishlist/item/${itemId}/move-to-cart/`);
}
